var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a-cascader',{attrs:{"options":_vm.options,"fieldNames":{ label: 'name', value: 'id', children: 'city' },"change-on-select":""},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }